var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#303c42;stroke-linecap:round;stroke-linejoin:round}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"id":"_Path_","data-name":"<Path>","className":"cls-1","d":"M11.33 29.5a2 2 0 0 0 2.17-1.89v-17a5.36 5.36 0 0 0-2.86-4.81 2.38 2.38 0 0 1-1.28-2.11V3H4.64v.91A2.38 2.38 0 0 1 3.36 6 5 5 0 0 0 .5 10.59v17a2 2 0 0 0 2.17 1.91z","key":0}),React.createElement("path",{"id":"_Path_2","data-name":"<Path>","className":"cls-1","d":"M4.64.5h4.73V3H4.64z","key":1}),React.createElement("path",{"className":"cls-1","d":"M13.28 9h.6a1.5 1.5 0 0 0 1.5-1.5V6a3 3 0 0 0-3-3H4","key":2})]))]);
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 15.88 30"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
